import { connect } from "react-redux";
import Layout from "./Layout.container";

export default connect(null, null)(Layout);